import { Logo } from "@/components/brand/Logo";
import { useStore } from "@/lib/store";

export default function PaymentCancel() {
  const { openCheckout, stock } = useStore();
  return (
    <main data-testid="payment-cancel-page" className="grain relative min-h-screen bg-[#F2EAE1]">
      <div className="relative mx-auto max-w-3xl px-5 py-10 sm:px-8">
        <Logo />
        <h1 className="font-display mt-32 text-5xl font-light leading-none tracking-tight sm:text-6xl">No rush — <span className="italic text-[#C85A32]">it's slow juice.</span></h1>
        <p className="mt-5 text-[#4A4543]">Your checkout was cancelled and you haven't been charged.{stock === 0 ? "" : " Your Slowpour is still waiting for you."}</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <button data-testid="cancel-retry-button" onClick={openCheckout} className="rounded-full bg-[#181615] px-7 py-3.5 font-semibold text-[#FDFBF7] hover:bg-[#C85A32]">Try again</button>
          <a data-testid="cancel-home-link" href="/" className="rounded-full border border-[#181615]/20 px-7 py-3.5 font-medium">Back to the shop</a>
        </div>
      </div>
    </main>
  );
}
